/**
 * Ponte entre a pagina do Copiloto e a extensao do Chrome.
 *
 * A extensao injeta um content script nesta origem que escuta
 * window.postMessage. A pagina nunca precisa saber o id da extensao: quem
 * responde ao ping e quem esta instalado. E assim que "conectar" vira um
 * clique — o token vai da pagina para a extensao sem o usuario copiar nada.
 */
import { COPILOTO_PONTE } from "@shared/copiloto-contracts";

export interface EstadoExtensao {
  versao: string;
  conectada: boolean;
  usuario?: string;
}

function esperarResposta<T>(tipo: string, timeoutMs: number): Promise<T | null> {
  return new Promise((resolve) => {
    const timer = setTimeout(() => {
      window.removeEventListener("message", ouvir);
      resolve(null);
    }, timeoutMs);
    function ouvir(ev: MessageEvent) {
      if (ev.source !== window || ev.data?.type !== tipo) return;
      clearTimeout(timer);
      window.removeEventListener("message", ouvir);
      resolve(ev.data as T);
    }
    window.addEventListener("message", ouvir);
  });
}

/** null = extensao nao instalada (ou nao respondeu). */
export async function detectarExtensao(timeoutMs = 800): Promise<EstadoExtensao | null> {
  const promessa = esperarResposta<{ type: string } & EstadoExtensao>(COPILOTO_PONTE.pong, timeoutMs);
  window.postMessage({ type: COPILOTO_PONTE.ping }, window.location.origin);
  const r = await promessa;
  return r ? { versao: r.versao, conectada: r.conectada, usuario: r.usuario } : null;
}

export async function conectarExtensao(dados: { token: string; wsUrl: string; usuario: string; expiraEm: string }): Promise<boolean> {
  const promessa = esperarResposta<{ type: string; ok: boolean }>(COPILOTO_PONTE.conectado, 2000);
  window.postMessage({ type: COPILOTO_PONTE.conectar, ...dados }, window.location.origin);
  const r = await promessa;
  return Boolean(r?.ok);
}

export async function desconectarExtensao(): Promise<void> {
  window.postMessage({ type: COPILOTO_PONTE.desconectar }, window.location.origin);
  await new Promise((r) => setTimeout(r, 200));
}
